import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
//import DialogTitle from '@material-ui/core/DialogTitle';
import Input from '@material-ui/core/Input';
import { Grid } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CircularProgress from '@material-ui/core/CircularProgress';
import { styles } from './styles';
import Apis from '../../../../../utils/Apis'

import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

function PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
}

const DialogTitle = withStyles(styles)(props => {
        const { children, classes, onClose } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                            <IconButton  aria-label="Close" className={classes.closeButton} onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                           ) : null}
            </MuiDialogTitle>
        );
});

class Edit extends Component {

    state = {
        requesting: false,
        id: this.props.id,
        name: this.props.name,
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.registered === 1) {
            this.props.onClose();
            return;
        }
        if (nextProps.registered === -1 && nextProps.error.body !== undefined) {
            this.props.onAlertMessage("error", nextProps.error.body.message);
            return;
        }
    }
    componentDidMount() {

    }

    onClose = () => {
        this.props.onClose();
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });

    };
    onUpdate = () => {
        const { requesting } = this.state;
        const { id, name } = this.state;
        if (requesting) {
            return;
        }

        if (name === '') {
            this.props.onAlertMessage("error", "Please input name!");
            return;
        }

        this.setState({ requesting: true });
        Apis.updateSiteName(id, name)
            .then(res => {

                this.setState({ requesting: false });
                let data = res.data;
                let status = data.status;
                if (status === 'success') {
                    this.props.onAlertMessage("success", "Site was successfully updated.");
                    this.props.onDoneEdit();
                    return
                } else {
                    this.props.onAlertMessage("error", data.message);
                }

            })
            .catch(err => {
                this.setState({ requesting: false });
                this.props.onAlertMessage("error", err.response.data.message);
            })
    }

    handleChangeSite = () => event => {
        this.setState({ site: event.target.value });
    };
    render() {
        const { classes } = this.props;
        const { open } = this.props;
        const { id, name, requesting } = this.state;
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={this.onClose}
                    PaperComponent={PaperComponent}
                    aria-labelledby="signup-dialog-title"
                    aria-describedby="signup-dialog-description">
                    <DialogTitle style={{ cursor: 'move' }} id="simple-dialog-title" onClose={this.onClose}/>

                    <DialogContent>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems='center'
                            className={classes.main_container}>

                            <Grid container
                                direction="column">
                                <FormControl
                                    className={classes.formControl}>
                                    <InputLabel shrink htmlFor="ibName" className={classes.inputlabel}>
                                        Name
                                    </InputLabel>
                                    <OutlinedInput
                                        id="ibName"
                                        placeholder="Site Name"
                                        classes={{
                                            root: classes.inputbaseRoot,
                                            input: classes.inputbaseInput,
                                        }}
                                        value={name}
                                        onChange={this.handleChange('name')}
                                        fullWidth
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <div className={classes.wrapper}>
                            <Grid item container direction="column" justify="center" alignItems="stretch">
                                <Button color="primary" variant="contained" className={classes.btnNewAccount}
                                    onClick={this.onUpdate}>
                                    Update
                                </Button>
                            </Grid>
                            {requesting && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

Edit.propTypes = {
    classes: PropTypes.object.isRequired,
};

// const RegisterlWrapped = withStyles(styles)(Register);


export default withStyles(styles)(Edit);
